import type { FaireProductEntity } from "../../entity_types/product";

export const p_wrcfr4zwac: FaireProductEntity = {
  token: "p_wrcfr4zwac",
  type: "product",
  name: "Little Cowboy Western Long Sleeve Romper - Baby Clothes",
  brandToken: "b_gro99lye",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/86fd6e82b7139b0c5b9d5909abbe39f1aa7332eedb56248a110bcc97724aa5f9.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a541501ed7614160ffbac713c151f6dfc1e8991734adbccc761d6e640ec24f5b.jpeg",
    "https://cdn.faire.com/fastly/68a51c97d92215110ac845f3d198ac9d444c79baef589968dfad820505b3c4a2.jpeg",
    "https://cdn.faire.com/fastly/9c2ad3e361f51b50db7109fcee105dfe8606ecbf8ad2e4924d291210a3af1674.jpeg",
  ],
  priceDollars: 16,
  description:
    "The Little Cowboy Western Long Sleeve Romper is a fun and cute romper for the rodeo or for showing off your cowboy spirit everyday\n\nFeatures:\n*Romper Color: Natural\n*Graphic Color: Brown\n*Material: 100% Cotton. Rib: 93% Cotton/7% Spandex\n*Features: Tagless inside neck label for an itch-free wear; 3 snap closure; cuffed sleeves; trendy bubble style\n*Fit: Infant Unisex\n*Care: Machine washable, tumble dry low, wash with like colors\n\nEach romper is hand pressed with love in our hometown warehouse.",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T03:44:23.635Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
